module.exports = __webpack_public_path__ + "static/justin_lin-0b91eceb8a7612203db1000224177616.jpg";